import { defineComponent as _defineComponent } from 'vue'
import SelectAllToggle from '@/components/common/SelectAllToggle.vue'
import { computed } from 'vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'BatchSideSheetFilter',
  props: {
    value: null,
    filterOptions: null,
    disabled: { type: Boolean }
  },
  emits: ['input'],
  setup(__props: any, { emit }) {

const props = __props as {
  value: { id: string; name: string }[]
  filterOptions: { count: never; id: string; name: string }[]
  disabled?: boolean
}





const selectedFilters = computed(() =>
  props.value.map((f) => props.filterOptions.findIndex((o) => o.id === f.id))
)

const model = computed({
  get() {
    return selectedFilters.value
  },
  set(newValue: number[]) {
    emit(
      'input',
      props.filterOptions.filter((_, i) => newValue.includes(i))
    )
  },
})

function toggleAll(isAllSelected: boolean) {
  if (isAllSelected) {
    model.value = []
  } else {
    model.value = props.filterOptions.map((_, i) => i)
  }
}

return { __sfc: true,props, emit, selectedFilters, model, toggleAll, SelectAllToggle }
}

})